
import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, Typography, Box } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MappedText from '../../study-page/create-study/analysis-page/components/clinical-info/mapText'; 

const SectionCards = ({ sectionData }) => {
    return (
        <Box p={1}>
            {Object.keys(sectionData).map(sectionName => (
                <Box p={1}>  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>
                                <b><MappedText text={sectionData[sectionName].name} /></b>, 
                                {sectionData[sectionName].children.length} <MappedText text="resources" />
                            </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {sectionData[sectionName].children.map(child => (
                            <Card key={child.id} variant="outlined" style={{ marginBottom: '1rem' }}>
                                <CardContent>
                                    <Typography variant="h6" component="h2">
                                        {child.name}
                                    </Typography>
                                    <Typography color="textSecondary">
                                        <strong><MappedText text="URL Prefix:" /> </strong>  <a target={"_blank"} href={child.url_prefix}>{child.url_prefix}</a>
                                    </Typography>
                                    <Typography color="textSecondary">
                                        <strong><MappedText text="URL Appendix" />:</strong>  {child.url_appendix}
                                    </Typography>
                                    <Typography color="textSecondary">
                                        <strong><MappedText text="Variable Category" />:</strong>  {child.variable_category}
                                    </Typography>
                                    <Typography variant="textSecondary" component="p">
                                        <strong><MappedText text="Description" />:</strong>  {child.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        ))}
                    </AccordionDetails>
                </Accordion>
                </Box>
            ))}
        </Box>
    );
};

export default SectionCards;
